<script>
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import Jewel04 from './Jewel04.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },
    mixins: [ Jewel04 ],

    data () {
      return {
        excepts: [
          'さらコレクション',
        ],
      }
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1,2]">
    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>
    <template #col1>
      <ItemList title="JR ◆◆◆◆" color="#44cd1f" :items="itemsJR7" />
    </template>
    <template #col2>
      <ItemList title="RR ◆◆◆◆" color="#edd50f" :items="itemsRR" />
      <ItemList title="HR ★★★★" color="#ff5d91" :items="itemsHR" />
    </template>
    <template #col3>
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>
    <template #col4>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
      <ItemList title="プリティーオールフレンズチャンネル" color="#a1c0fa" :items="itemsPAF" />
    </template>

    <template #col5>
    </template>
    <template #col6>
    </template>
    <template #col7>
    </template>
    <template #col8>
    </template>

    <template #col9>
      <ItemList title="ニコチケ PR ★★★" color="#ffa1bc" :items="itemsNicoPR" />
      <ItemList title="ニコチケ SR ★★" color="#00c7da" :items="itemsNicoSR" />
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | first(20)" />
    </template>
    <template #col10>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | rest(20)" :isOrphan="true" />
      <Status :date="date" :items="items" :showKira="true" :showNico="true" :showHR="true" />
    </template>
  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: 50px;
  //   }
  // }
</style>
